import React, { useEffect } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

function ContentTextSection({ data }) {
  const { header, subheader, headerText, textSections } = data

  const options = {
    renderText: text => {
      return text.split('\n').reduce((children, textSegment, index) => {
        return [...children, index > 0 && <br key={index} />, textSegment]
      }, [])
    },
  }

  useEffect(() => {
    const func = async () => {
      window.scrollTo(0, 0)
    }
    func()
  }, [])

  return (
    <div className="bb-page container">
      <h1 className="text-primary">{header}</h1>
      <h6>{documentToReactComponents(subheader, options)}</h6>
      <div>{documentToReactComponents(headerText, options)}</div>
      <br />
      {textSections
        ?.map(i => i.fields)
        .map(section => (
          <p style={{ marginBottom: '22px' }}>
            <h3 className="bb-page-headline">
              <strong>{section.title}</strong>
            </h3>
            {documentToReactComponents(section.text, options)}
          </p>
        ))}
    </div>
  )
}

export default ContentTextSection
